import type { AppState } from 'src/reducers';
import { createSelector, type Selector } from 'reselect';
import type { CardViewDataInputs, CardViewOptionalInputs } from 'src/components/StandardCardView/UIData.types';
import type { SubheaderSlice } from 'src/components/Subheader/Subheader.slice';
import type { BasicPivotItem } from 'src/worker/pivotWorker.types';
import type { TenantConfigViewData } from 'src/dao/tenantConfigClient';
import processDataForCardView from 'src/components/StandardCardView/CardViewDataProcessor';
import type { CartItem, CartItemType } from '../../../AssortmentCart/AssortmentCart.types';
import { STYLE_ID } from 'src/utils/Domain/Constants';

const getSearchData: Selector<AppState, BasicPivotItem[]> = (state) => {
  return state.pages.assortmentBuild.addStyles.searchData;
};

const getLevel: Selector<AppState, string> = (state) => {
  return state.pages.assortmentBuild.addStyles.level;
};

const getCartItems: Selector<AppState, CartItem[]> = (state) => {
  return state.cart.cartItems;
};

const getCartItemType: Selector<AppState, CartItemType> = (state) => {
  return state.pages.assortmentBuild.addStyles.cartItemType;
};

const getViewConfig: Selector<AppState, TenantConfigViewData> = (state) => {
  return state.pages.assortmentBuild.addStyles.viewDefn;
};

const getSubheader: Selector<AppState, SubheaderSlice> = (state) => {
  return state.subheader;
};

export const getSelectedItems: Selector<AppState, BasicPivotItem[]> = (state) => {
  return state.pages.assortmentBuild.addStyles.selectedItemsForCart;
};

export const getAssortmentCartLink: Selector<AppState, string | undefined> = (state) => {
  return state.perspective.viewLinks.find((view) => view.name === 'Assortment Cart')?.link;
};

export function getGroupedData(
  level: string,
  cartItemType: CartItemType,
  cartItems: CartItem[],
  styles: BasicPivotItem[],
  config: TenantConfigViewData,
  subheader: SubheaderSlice,
  selectedItems: BasicPivotItem[],
) {
  if (styles && config && subheader) {
    const filteredStyles = styles || [];
    if (level === 'styles') {
      filteredStyles.filter((style) => {
        return cartItems.findIndex((cartItem) => cartItem.id === style[STYLE_ID] && cartItem.type === cartItemType) < 0;
      });
    } else if (level === 'stylecolors') {
      // FIXME: update logic to work with stylecolors
      // filteredStyles.filter((style) => {
      //   const foundCartItem = cartItems.find(
      //     (cartItem) => cartItem.id === style[STYLE_ID] && cartItem.type === cartItemType
      //   );
      //   if (!isNil(foundCartItem)) {
      //     return (
      //       foundCartItem.findIndex((childItem) => {
      //         return childItem.id === style.id && childItem.type === cartItemType;
      //       }) < 0
      //     );
      //   }
      //   return true;
      // });
    }

    const dataInputs: CardViewDataInputs = {
      styles,
      subheader,
      defns: {
        view: config,
        rollup: {} as TenantConfigViewData,
      },
    };
    const optionalInputs: CardViewOptionalInputs = {
      selectedItems,
    };
    return processDataForCardView(dataInputs, optionalInputs);
  }
  return [];
}

export const getProcessedData = createSelector(
  getLevel,
  getCartItemType,
  getCartItems,
  getSearchData,
  getViewConfig,
  getSubheader,
  getSelectedItems,
  getGroupedData,
);
